import React from "react";
import {
  Box,
  Checkbox,
  HStack,
  Icon,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";

interface IconToggleCardProps {
  icon: any;
  isChecked: boolean;
  label: string;
  name: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const IconToggleCard: React.FC<IconToggleCardProps> = ({
  icon,
  isChecked,
  label,
  name,
  onChange,
}) => {
  const cardBg = useColorModeValue("white", "#23272F");
  const cardBorder = useColorModeValue("#e5e7eb", "#444");
  const activeBg = useColorModeValue("brand.50", "rgba(66, 153, 225, 0.12)");
  const activeBorder = useColorModeValue("brand.400", "brand.300");
  const labelColor = useColorModeValue("gray.800", "white");
  const mutedColor = useColorModeValue("gray.500", "gray.400");
  const iconBg = useColorModeValue("gray.100", "whiteAlpha.100");
  const activeIconBg = useColorModeValue(
    "brand.100",
    "rgba(66, 153, 225, 0.18)",
  );

  return (
    <Box
      as="label"
      cursor="pointer"
      border="1px solid"
      borderColor={isChecked ? activeBorder : cardBorder}
      borderRadius="xl"
      bg={isChecked ? activeBg : cardBg}
      px={4}
      py={3}
      transition="all 0.2s ease"
      _hover={{
        borderColor: isChecked ? activeBorder : mutedColor,
        transform: "translateY(-1px)",
      }}
    >
      <Checkbox name={name} isChecked={isChecked} onChange={onChange} srOnly>
        {label}
      </Checkbox>
      <HStack spacing={3} align="center">
        <Box
          w="10"
          h="10"
          borderRadius="lg"
          display="flex"
          alignItems="center"
          justifyContent="center"
          bg={isChecked ? activeIconBg : iconBg}
          color={isChecked ? "brand.400" : mutedColor}
        >
          <Icon as={icon} boxSize={5} />
        </Box>
        <Text fontWeight="bold" color={labelColor}>
          {label}
        </Text>
      </HStack>
    </Box>
  );
};
